import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { EntityState, EntityStateModel } from '../entity/entity.state';
import { EntityActions as EA } from '../entity/entity.action';
import { TeamActions as TA } from './team.action';
import { Team } from './../../models/dto/team.model';
import { TeamService } from 'app/modules/teams/team.service';

// Inherit the parent state model with correct entity type.
export class TeamStateModel extends EntityStateModel<Team>{}

@State<TeamStateModel>({
	name: 'team',
	defaults: {
    entities: [],
    current: null,
    expires: 0,
    loading: false,
  }
})

@Injectable()
export class TeamState extends EntityState<Team> {

  @Selector()
  static loading(state: TeamStateModel) {
    return state.loading;
  }

  // DI creates a concrete service that implements AbstractCrudService for
  // use by the parent EntityState.
	constructor(
    private concreteEntityService: TeamService,
  ) {
    super(
      concreteEntityService,
      // Optional expiresIn argument as `(5 * 60 * 1000)`. 5 minute default.
    );
  }

  // Implement common CRUD actions by delegating to parent class.
  @Action(TA.Get)
	taGet(ctx: StateContext<TeamStateModel>, payload: EA.Get) {
    return this.get(ctx, payload);
  }

  @Action(TA.GetIndex)
	taGetIndex(ctx: StateContext<TeamStateModel>, payload: EA.GetIndex) {
    return this.getIndex(ctx, payload);
  }
}
